import React from 'react'
import './styles.css'
import { get } from 'lodash'
import { isSite } from '~/tools/isSite'
import VideoJSPlayer from '~/components/VideoPlayer'
import { getLocalizedVal } from '~/tools/localization/helpers';

const getSeasonIndexFromTitle = (video) => {
	let current = video.showData.seasons[video.currentSeason].title.split(' ')[1]
	if (isNaN(current)) current = video.currentSeason + 1
	return current
}

const EpisodeOverlay = (props) => {
	const { video } = props.args
	const { seasons } = video.showData
	const seasonPass = seasons[video.currentSeason].seasonPass

	return ( 
		<div className="overlay-player">
			<VideoJSPlayer
				{...props.args}
				fileType={video.fileType}
				isEpisode={true}
				overlay={true}
				videoId={video.gist.id}
				user={props.user}
				isFree={video.gist.free}
				autoplay={window.settings.features['auto_play']}
				videoTag={get(window.settings, 'advertising.videoTag')}
				startTime={video.watchedTime}
			/>
			<div className="overlay-episode-details">
				<div className="episode-name">
					<span className="season-episode-details">
						{`S${getSeasonIndexFromTitle(video)}:${isSite('bingeflix') ? 'P' : 'E'}${!seasonPass ? video.currentEpisode + 1 : video.currentEpisode}`}
					</span>
					<span className="name">{video.title}</span>
				</div>
				{ (video.nextEpisode && video.nextEpisode.contentType !== 'SEASON_PASS') &&
					<div className="next-episode" onClick={(e) => video.playNextEpisode(e)}>
						<div className="next-episode-img">
							<div className="image" style={{ backgroundImage: `url(${video.nextEpisode.gist.videoImageUrl})` }}></div>
						</div>
						<div className="next-episode-title-container">
							<p className="next-copy site-color">{getLocalizedVal(window.settings, 'genericMessages', 'nextLabel')}</p>
							<p className="next-episode-title">{video.nextEpisode.gist.title}</p>
						</div>
					</div>
				}
			</div>
		</div>
	)
}

export default EpisodeOverlay;